module Meevo.Plugins.CustomBranding {
    "use strict";

    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;
    import MeevoFile = Meevo.Model.MeevoFile;

    /**
     * Cover Section of Custom Branding
     */
    export class CoverSection extends CustomBrandingBaseSection {
        public stockImages: Array<MeevoFile>;
        private sloganStyleConfig: IStyleConfig;

        constructor(params: Meevo.Model.ISectionParamsBaseDataService) {
            super(params);         

            this.cover = true;
        }

        /**
         * Build style object for slogan
         * */
        private buildSloganStyles(): void {
            this.sloganStyle = {
                'color': this.model.customMessageColor || '#000',
                'font-family': this.model.customMessageFont,
                'font-weight': this.model.customMessageFontBold ? 'bold' : 'normal',
                'font-style': this.model.customMessageFontItalicize ? 'italic' : 'normal',
                'text-decoration': this.model.customMessageFontUnderline ? 'underline' : 'none',
            };
        }

        /**
         * Select tab
         * @param {ITab} tab
         * */
        public selectTab(tab: ITab): void {
            this.model.selectedBackgroundImageOption = tab.tabId;
            this.selectedTab = this.model.selectedBackgroundImageOption - 1
        }

        /**
         * Set active tab
         * */
        public setActiveTab(): number {
            return this.model.selectedBackgroundImageOption - 1;
        }

        /**
         * Here you can implement needed logic before saving the form
         */
        public preSave(): void {

            this.busyService.start();
            this.model['imagesSavedToStoragePromise'] = this.$q.all([
                this.saveImageToStorage(this.model.displayLogoImageObject),
                this.saveImageToStorage(this.model.customBackgroundImageObject)
            ])
                .then((response: Array<IStorageFile | any>) => {})
                .catch(error => {
                    this.loggingService.trace(error.statusText);
                })
                .finally(() => {
                    this.busyService.stop();
                });
            if (Model.Guard.isSomething(this.model.displayLogoImageObject))
                this.model.displayLogoImage = this.model.displayLogoImageObject.fileGuid;
            if (Model.Guard.isSomething(this.model.customBackgroundImageObject))
            this.model.customBackgroundImage = this.model.customBackgroundImageObject.fileGuid;

            this.checkForUploadedImage()
        }

        public checkForUploadedImage(): void {
            if (!this.model.displayLogoImage  && this.model.displayLogo) {
                this.modalService.alert('MESSAGE_CUSTOM_BRANDING_NO_LOGO_UPLOADED');
                this.model.displayLogo = false;
            }
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         */
        public activate(): void {
            super.activate();

            this.selectedTab = this.model.selectedBackgroundImageOption - 1;

            if (typeof this.model.selectedBackgroundImageOption === 'undefined') {
                this.model.selectedBackgroundImageOption = TabIdsEnum.stockLibrary;
            }
            this.buildSloganStyles();

            this.busyService.start();
            this.$q.all([
                this.getImageUrl(StorageTypeEnum.CustomBrandingLogoImage, this.model.displayLogoImage),
                this.getImageUrl(StorageTypeEnum.CustomBrandingBackgroundImage, this.model.customBackgroundImage),
                this.getStockImages()
            ])
                .then((response: Array<IStorageFile | any>) => {
                    let [displayLogoImageObject, customBackgroundImageObject, stockImages] = response,
                        stockImagesArray: Array<MeevoFile> = [];

                    this.model.displayLogoImageObject = displayLogoImageObject.data || {};
                    this.model.customBackgroundImageObject = customBackgroundImageObject.data || {};
                    for (let image in stockImages.data) {
                        stockImagesArray.push(stockImages.data[image]);
                    }

                    // select the first stock image by default
                    if (!this.model.stockBackgroundImage) {

                        if (stockImagesArray.length == 0) {
                            console.log("Could not find stock background images");
                            return;
                        } else {
                            this.model.stockBackgroundImage = stockImagesArray[0].fileGuid;
                        }

                    }

                    this.stockImages = stockImagesArray;
                })
                .catch(error => {
                    this.loggingService.trace(error.statusText);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * @param {MeevoFile} image
         * Select Stock Image
         */
        public selectStockImage(image: MeevoFile): void {
            this.model.stockBackgroundImage = image.fileGuid;
        }

        /**
         * Get all stock images
         */
        private getStockImages(): angular.IPromise<any> {
            return this.dataService.customMethodData(`api/storage/StockImages/${StorageTypeEnum.StockImage}`, 'GET', null);
        }

        get sloganStyle(): IStyleConfig {
            return this.sloganStyleConfig;
        }

        set sloganStyle(style: IStyleConfig) {
            this.sloganStyleConfig = style;
        }
    }

}